import * as React from 'react';

import {colors} from '../../../colors/colors';

type Props = {
    value: string;
    fieldName: string;
    isLeadCard?: boolean;
};

export function RelationshipString(props: Props) {
    const useUserColor =
        (!props.isLeadCard && props.fieldName === 'owner') || props.fieldName === 'creator';

    return <div style={useUserColor ? {color: colors.orangeDk} : undefined}>{props.value}</div>;
}
